<template>
    <InformeCard id="entradas_otros" name="entradas_otros" collapsable="true" title="Entradas otros">
        <div class="table-responsive">
            <table class="table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th>TIPO DE PRECIO</th>
                        <th>MÉTODO DE PAGO</th>
                        <th>CONCEPTO</th>
                        <th>TAQUILLERO</th>
                        <th>PRECIO</th>
                        <th>VENDIDAS</th>
                        <th>TOTAL</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(otros, index) in informe_entradas_otros">
                        <tr :key="index">
                            <td>{{ otros.description }}</td>
                            <td>{{ otros.metodo_pago | formatear_metodo_pago_entrada }}</td>
                            <td>{{ otros.concepto }}</td>
                            <td>{{ otros.nombre + ' ' + otros.apellidos }}</td>
                            <td>{{ otros.precio_real | formatear_precio }}</td>
                            <td>{{ otros.total }}</td>
                            <td>{{ otros.precio_real * otros.total | formatear_precio }}</td>
                        </tr>
                    </template>
                    <tr>
                        <td colspan="5">TOTAL</td>
                        <td>{{ getTotalEntradasOtros() }}</td>
                        <td>{{ getTotalVenta() | formatear_precio }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </InformeCard>
</template>

<script>
import InformeCard from "../InformeCard";

export default {
    props: ['event_id', 'sesion_id'],
    data() {
        return {
            informe_entradas_otros: null
        }
    },
    created() {
        this.getInformeEntradasOtros();
    },
    methods: {
        getTotalEntradasOtros() {
            if (!this.informe_entradas_otros) {
                return 0;
            }
            var total = 0;

            if (this.informe_entradas_otros) {
                for (var i = 0; i < this.informe_entradas_otros.length; i++) {
                    total += this.informe_entradas_otros[i].total;
                }
            }

            return total;
        },
        getTotalVenta() {
            if (!this.informe_entradas_otros) {
                return 0;
            }
            var total = 0;

            if (this.informe_entradas_otros) {
                for (var i = 0; i < this.informe_entradas_otros.length; i++) {
                    let rec = this.informe_entradas_otros[i].total * this.informe_entradas_otros[i].precio_real;
                    total += rec;
                }
            }

            return total;
        },
        getInformeEntradasOtros() {
            const params = {
                filters: {
                    sesion_id: this.sesion_id,
                },
                evento_id: this.event_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.informe.entradas-otros'), params).then(res => {
                this.informe_entradas_otros = res.data.data;
            });
        },
    },
    components: {
        InformeCard,
    }
}
</script>